// Initialize all vendor libraries
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import AOS from 'aos';
import { Swiper } from 'swiper';
import GLightbox from 'glightbox';

// Initialize AOS (Animate On Scroll)
export const initAOS = () => {
  AOS.init({
    duration: 1000,
    easing: 'ease-in-out',
    once: true,
    mirror: false
  });
};

// Initialize GLightbox
export const initGLightbox = () => {
  GLightbox({
    autoplayVideos: false,
  });
};

// Initialize Swiper instances
export const initSwipers = () => {
  // Initialize all swiper instances with init-swiper class
  const swiperElements = document.querySelectorAll('.swiper.init-swiper');
  console.log('Found Swiper elements:', swiperElements.length);
  
  swiperElements.forEach((element, index) => {
    const configScript = element.querySelector('.swiper-config');
    if (configScript && !element.swiper) {
      try {
        const config = JSON.parse(configScript.textContent);
        console.log(`Initializing Swiper ${index + 1} with config:`, config);
        new Swiper(element, config);
        console.log(`Swiper ${index + 1} initialized successfully`);
      } catch (error) {
        console.error('Error parsing Swiper config:', error);
      }
    } else if (element.swiper) {
      console.log(`Swiper ${index + 1} already initialized`);
    }
  });
};

// Initialize PureCounter (if available)
export const initPureCounter = () => {
  if (window.PureCounter) {
    new window.PureCounter();
  }
};

// Initialize scroll to top functionality
export const initScrollTop = () => {
  const scrollTopBtn = document.getElementById('scroll-top');
  
  if (scrollTopBtn) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        scrollTopBtn.classList.add('show');
      } else {
        scrollTopBtn.classList.remove('show');
      }
    });
    
    scrollTopBtn.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
};

// Initialize mobile menu toggle
export const initMobileMenu = () => {
  const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
  const navmenu = document.querySelector('#navmenu');
  
  if (mobileNavToggle && navmenu) {
    mobileNavToggle.addEventListener('click', function() {
      navmenu.classList.toggle('mobile-nav-active');
    });
  }
};

// Initialize dropdown menus
export const initDropdowns = () => {
  const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
  
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const dropdown = this.parentElement;
      dropdown.classList.toggle('active');
    });
  });
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.dropdown')) {
      document.querySelectorAll('.dropdown').forEach(dropdown => {
        dropdown.classList.remove('active');
      });
    }
  });
};

// Initialize all libraries
export const initAllLibraries = () => {
  initAOS();
  initGLightbox();
  initSwipers();
  initPureCounter();
  initScrollTop();
  // initMobileMenu(); // Removed - React handles mobile navigation
  initDropdowns();
};

export { AOS, Swiper, GLightbox };
